@if (model) {
    <ds-tabs-group
        class="sport-navigation-tab"
        indicator="underline"
        size="small"
        variant="vertical"
        [scrollable]="true"
        [fullWidthTabs]="false"
        [scrollDistance]="scrollConfig?.sportScrollSize ?? 0"
        [activeTab]="activeId"
        (activeTabChanged)="selected($event)">
        @for (tab of model; track tab.id) {
            @if (!tab.isHidden && isVideoStreamingEnabled(tab.id)) {
                <ds-tab [name]="tab.id.toString()">
                    <ng-container *dsTabHeader="let selected">
                        <a class="tab-vertical-content" [msLink]="tab.url" [vnSpeculativeLink]="tab.url ?? ''">
                            @if (tab.icon) {
                                <vn-icon class="tab-vertical-icon" size="16" [name]="tab.icon" />
                            }
                            <span>
                                {{ tab.title }}
                                @if (!!count(tab)) {
                                    <ds-notification-bubble size="medium" [variant]="selected ? 'primary' : 'neutral'">
                                        {{ count(tab) }}
                                    </ds-notification-bubble>
                                }
                            </span>
                        </a>
                    </ng-container>
                </ds-tab>
            }
        }
    </ds-tabs-group>
}
